import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "memberCenter-coupon_secondary",
  "use": "memberCenter-coupon_secondary-usage",
  "viewBox": "0 0 100 220",
  "content": "<symbol viewBox=\"0 0 100 220\" xmlns=\"http://www.w3.org/2000/svg\" id=\"memberCenter-coupon_secondary\"><path d=\"M6 176H94V192C94 194.209 92.2091 196 90 196H10C7.79086 196 6 194.209 6 192V176Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol